import { z } from 'zod';

export const channelMetricsSchema = z.object({
  channel: z.string(),
  sent: z.number(),
  delivered: z.number(),
  failed: z.number(),
});
export type ChannelMetrics = z.infer<typeof channelMetricsSchema>;

export const recentNotificationSchema = z.object({
  id: z.string(),
  channel: z.string(),
  eventType: z.string(),
  status: z.string(),
  to: z.string(),
  createdAt: z.string(),
});
export type RecentNotification = z.infer<typeof recentNotificationSchema>;

export const metricsSummarySchema = z.object({
  totalSent: z.number(),
  delivered: z.number(),
  failed: z.number(),
  deliveryRate: z.number(),
  byChannel: z.array(channelMetricsSchema),
  activeApps: z.number(),
  recent: z.array(recentNotificationSchema),
});
export type MetricsSummary = z.infer<typeof metricsSummarySchema>;
